import React, { Fragment, useMemo } from "react";

import { useSelector } from "react-redux";

import { BootPopup } from "@app/components/insiders";
import { InvoiceEditMain } from "@app/components/invoiceEdit/invoiceEditMain";
import { Case, CaseElse, Switch, useWindowDimensions } from "@app/contexts";
import { useComponentStack } from "@app/contexts/useComponentStack";
import { useKeyword } from "@app/contexts/useKeyword";
import { EComponentStack, EMenuCmdTab } from "@app/state/constants";
import { CONST_INSIDER_MAIN } from "@app/state/insider/constants";
import { useFxSelector } from "@app/statefx";
import { schema } from "@app/statefx/schema";

import { LoadingPage, WorkInProgress } from "../startup/VerificationRequired";
import { BankAccountsDefinition } from "./accounts";
import { ContractorsMain } from "./contractors/ConstractorsMain";
import "./insiders.scss";
import { InvoiceMain } from "./invoice/InvoiceMain";
import { InvoiceIssuerDefinition } from "./issuer";
import ListPage from "./lists/ListsMain";
import { FiscalBooksPage } from "./serials";
import { UserConfigForm } from "./usercfg/usercfg";

export const IndividualHome = () => {
  useComponentStack(EComponentStack.InvoiceOverall);
  const keyWord = useKeyword();
  const { width, rightReserved, jgDrawerHeight } = useWindowDimensions();
  const renderKey = useFxSelector(schema.uiRenderKey.select);
  // const lock = useFxSelector(schema.lock.select);
  // const isBooting = useMemo(() => (lock || "").startsWith("$:bootup"), [lock]);
  return (
    <div
      key={renderKey}
      className="insiders"
      // style={{
      //   width: `${width - rightReserved}px`,
      //   height:`${jgDrawerHeight - 10 }px`,
      //   paddingRight: "3px",
      //   background: "#ffffff",
      // }}
    >
      <Switch value={keyWord}>
        <Case when={EMenuCmdTab.CMD_BGIM_CLIENTS}>
          <div className="invoice-main">
            <ContractorsMain />
          </div>
        </Case>
        <Case when={EMenuCmdTab.CMD_BGIM_MESSAGES}>
          <div className="invoice-main">
            <InvoiceMain />
          </div>
        </Case>
        <Case when={EMenuCmdTab.CMD_BGIM_INVOICE}>
          {process.env.REACT_APP_MODE === "REACT" ? (
            <InvoiceEditMain />
          ) : (
            <Fragment />
          )}
        </Case>
        <Case when={EMenuCmdTab.CMD_BGIM_INVOICE_TRACKING}>
          <div className="invoice-main">
            <h1>Tracking</h1>
          </div>
        </Case>
        <Case
          when={[
            (x) =>
              [
                EMenuCmdTab.CMD_BGIM_INVOICE_OVERALL,
                CONST_INSIDER_MAIN,
              ].includes(x),
          ]}
        >
          <div className="invoice-main">
            <InvoiceMain />
          </div>
        </Case>
        <Case when={EMenuCmdTab.CMD_BGIM_REPORTS}>
          <div className="invoice-main">
            <ListPage />
          </div>
        </Case>
        <Case when={EMenuCmdTab.CMD_BGIM_LICENSE}>
          <div className="invoice-main">
            <h1>License Info</h1>
            <WorkInProgress />
          </div>
        </Case>
        <Case when={EMenuCmdTab.CMD_BGIM_OAUTH2}>
          <div className="invoice-main">
            <h1>OAuth2</h1>
          </div>
        </Case>
        <Case when={EMenuCmdTab.CMD_BGIM_EMITENT}>
          <div className="invoice-main">
            <InvoiceIssuerDefinition />
          </div>
        </Case>
        <Case when={EMenuCmdTab.CMD_BGIM_INVOICE_SERIES}>
          <div className="invoice-main">
            <FiscalBooksPage />
          </div>
        </Case>
        <Case when={EMenuCmdTab.CMD_BGIM_ACCOUNTS}>
          <div className="invoice-main">
            <BankAccountsDefinition />
          </div>
        </Case>
        <Case when={EMenuCmdTab.CMD_BGIM_USERCONFIG}>
          <div className="invoice-main">
            <UserConfigForm />
          </div>
        </Case>
        <CaseElse>
          <div />
        </CaseElse>
      </Switch>

      <BootPopup />

      {/* <Switch value={isBooting}>
        <Case when={true}>
        </Case>
      </Switch> */}
    </div>
  );
};
